import { combineReducers } from '@reduxjs/toolkit';
import { createFetchReducer, DefaultState } from 'store/setLocalStore';

import { npv2Reducer, Npv2State } from 'store/booking/appointment/npv2/reducers';
import { appointmentDetailsReducer, AppointmentDetailsState } from './appointmentDetails/reducers';
import { groupedVisitTypesReducer, GroupedVisitTypesState } from './groupedVisitTypes/reducers';
import { visitTypesReducer, VisitTypesState } from './visitTypes/reducers';
import { timeSlotsReducer, TimeSlotsState } from './timeSlots/reducers';
import * as actions from './actions';

export type AppointmentState = {
  appointmentDetails: AppointmentDetailsState;
  groupedVisitTypes: GroupedVisitTypesState;
  visitTypes: VisitTypesState;
  timeSlots: TimeSlotsState;
  initializedBookingInformation: DefaultState;
  npv2State: Npv2State;
};

export const appointmentReducer = combineReducers({
  appointmentDetails: appointmentDetailsReducer,
  groupedVisitTypes: groupedVisitTypesReducer,
  visitTypes: visitTypesReducer,
  timeSlots: timeSlotsReducer,
  initializedBookingInformation: createFetchReducer(actions.INIT_BOOKING_INFORMATION, true),
  npv2State: npv2Reducer
});
